import React from 'react'

const SupplierReceivingReport = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Supplier Receiving Report</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Reports</li>
            <li className="breadcrumb-item active">Supplier Receiving Report</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Supplier Receiving Report</h5>
                <p>Supplier receiving report content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SupplierReceivingReport

